import Vue from "vue";
import Router from "vue-router";

import AppHeader from "./cuerpo/Header";
import AppFooter from "./cuerpo/Footer";

import Index from "./vistas/Paso1/Home";






Vue.use(Router);


const router = new Router({
    linkExactActiveClass: "active",
    mode: "history",
    routes: [
        {
            path: "/",
            components: {
                header: AppHeader,
                default: Index,
                footer: AppFooter,
            },
            name: "p1",
        },
       
        {
            path: "*",
            name: "404",
            redirect: {name: 'p1'}
        }
    ],
    
});



export default router;
